var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { performAxiosRequest } from "../requestHelper";
import { getCollectivePrices, getCollectivePricesWithDiscountCoupon, postPayment, postPaymentResponse } from './paymentApi';
export const submitPayment = (body) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postPayment(body);
        return response.status === 200 ? response.data : null;
    }));
});
export const submitPaymentResponse = (body) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postPaymentResponse(body);
        return response.status === 200 ? response.data : null;
    }));
});
export const getCollectivePrice = (collectiveId, isTerritorySpecial, serviceId = 1) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getCollectivePrices(collectiveId, isTerritorySpecial, serviceId);
        return response.status === 200 ? response.data : null;
    }));
});
export const getCollectivePriceWithDiscountCoupon = (collectiveId, discountCode, isTerritorySpecial) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getCollectivePricesWithDiscountCoupon(collectiveId, discountCode, isTerritorySpecial);
        return response.status === 200 ? response.data : null;
    }), [404], false // Retorna false si el cupon no es valido
    );
});
